"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    head: {
      fontSize: '0.875rem',
      lineHeight: '1.375rem',
      fontWeight: 'bold',
      color: theme.palette.secondary.main
    }
  };
});
function SttTableCell(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], _extends({
    classes: classes
  }, props));
}
var _default = SttTableCell;
exports["default"] = _default;